export var TimelineItemType;
(function (TimelineItemType) {
    TimelineItemType[TimelineItemType["EVENT"] = 0] = "EVENT";
    TimelineItemType[TimelineItemType["REPLY"] = 9] = "REPLY";
    TimelineItemType[TimelineItemType["PHONE_CALL"] = 150] = "PHONE_CALL";
    TimelineItemType[TimelineItemType["NOTE"] = 160] = "NOTE";
    TimelineItemType[TimelineItemType["CHAT_MESSAGE"] = 170] = "CHAT_MESSAGE";
    TimelineItemType[TimelineItemType["CSAT"] = 320] = "CSAT";
})(TimelineItemType || (TimelineItemType = {}));
export var CsatRatingType;
(function (CsatRatingType) {
    CsatRatingType[CsatRatingType["POSITIVE"] = 10] = "POSITIVE";
    CsatRatingType[CsatRatingType["NEUTRAL"] = 20] = "NEUTRAL";
    CsatRatingType[CsatRatingType["NEGATIVE"] = 30] = "NEGATIVE";
})(CsatRatingType || (CsatRatingType = {}));
//# sourceMappingURL=timeline.js.map